import React, { Component } from 'react';
import { connect } from 'react-redux';
import './WeHaveWorkedWith.scss';

import IIFYMLogo from '../../../assets/images/customer-logos/iifym.png';
import SellrLogo from '../../../assets/images/customer-logos/sellr.png';
import iLeadsLogo from '../../../assets/images/customer-logos/ileads.png';
import SelfDefenseLogo from '../../../assets/images/customer-logos/self-defense.png';
import WhiteCoatLogo from '../../../assets/images/customer-logos/white-coat.png';
import AthleteBeatLogo from '../../../assets/images/customer-logos/the-athlete-beat.png';

class OurProcess extends Component {
  render() {
    return (
      <section id="we-have-worked-with">
        <div className="container">
          <div className="logo-holder">
            <div className="blue-bg-holder d-flex flex-wrap">
              <div className="logo-item">
                <img src={IIFYMLogo} />
              </div>

              <div className="logo-item">
                <img src={SellrLogo} alt="Sellr Logo" />
              </div>

              <div className="logo-item">
                <img src={iLeadsLogo} alt="iLeads Logo" />
              </div>

              <div className="logo-item">
                <img src={SelfDefenseLogo} alt="SelfDefense Logo" />
              </div>

              <div className="logo-item">
                <img src={WhiteCoatLogo} alt="WhiteCoat Logo" />
              </div>

              <div className="logo-item">
                <img src={AthleteBeatLogo} alt="Athlete Beat Logo" />
              </div>
            </div>

            {/* <a href="#" className="blue-gradient-btn">View More Clients</a> */}
          </div>

          <div className="right-content-holder">
            <span className="count">- Clients</span>
            <h3>We've Worked with the Best</h3>
            <p>Pixel8 has worked with companies large and small. Our services range from single landing pages to full scale SAAS applications. Contact us now to see what we can do for you.</p>
          </div>
        </div>
      </section>
    )
  }
}

export default connect()(OurProcess);



// WEBPACK FOOTER //
// ./src/components/Common/WeHaveWorkedWith/WeHaveWrokedWith.js